const TipoSocDistrDivOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
    label: "Sociedad Nacional",
    value: "Sociedad Nacional",
  },
  {
    label: "Sociedad Extranjera",
    value: "Sociedad Extranjera",
  }
];

export default TipoSocDistrDivOptions;